<script>
export let registrations; // or players ?
export let jersey_form_changes;
export let team_instance_id;
export let conference_id;


export let jersey_numbers_has_options; // true ?
export let jersey_numbers_options; // 0 - 99 (Yes).

export let jersey_size_option;
export let jersey_sizes_available;

console.log(jersey_sizes_available);

export let socks_size_option;
export let socks_sizes_available;


export let jersey_sizes_available_message;

console.log(jersey_sizes_available_message);


export let jerseys_form_deadline;

// let jerseys_form_deadline_str = jerseys_form_deadline

import dayjs from 'dayjs';
let jerseys_form_deadline_str = dayjs(jerseys_form_deadline).toString();

console.log(jerseys_form_deadline_str);



export let last_year_jerseys_socks_info;

// console.log(last_year_jerseys_socks_info);



// import JerseyThumb, { findDuplicates, changesToBeSaved } from 'components/views/my/team/thumbs/Jersey.svelte';
import JerseyThumb from 'components/views/my/team/thumbs/Jersey.svelte';
import ErrorPanelBlock from 'components/elements/ErrorPanelBlock.svelte';

import MsgCard from 'components/elements/MsgCard.svelte';



// Could (but does not right now) vary between teams.
jersey_numbers_options = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99]




let jersey_sizes_players;
let jersey_sizes_goalies;

if (jersey_sizes_available) {

	let jersey_sizes_split = jersey_sizes_available.split(':');

	jersey_sizes_players = [];
	jersey_sizes_goalies = [];

	jersey_sizes_split.forEach(jersey_size => {

		let number_of_size = parseInt(jersey_size.split('-')[0]);
		let size_label = jersey_size.split('-')[1];

		if (size_label.includes('!G')) {
			size_label = size_label.split('!G')[0];
			jersey_sizes_goalies.push({ size_value: size_label, size_name: size_label, number: number_of_size });
		} else {
			jersey_sizes_players.push({ size_value: size_label, size_name: size_label, number: number_of_size });
		}

	});


	// message string

	let jersey_sizes_numbers_str = '';
	for (var jersey_size of jersey_sizes_players) {
		jersey_sizes_numbers_str += `${jersey_size.number} ${jersey_size.size_name}, `;
	}

	for (var jersey_size of jersey_sizes_goalies) {
		jersey_sizes_numbers_str += `${jersey_size.number} ${jersey_size.size_name} (Goalies), `;
	}

	jersey_sizes_numbers_str = jersey_sizes_numbers_str.substring(0, jersey_sizes_numbers_str.length - 2);

	jersey_sizes_available_message = `For jersey sizes you have: ${jersey_sizes_numbers_str}.`;

	console.log(jersey_sizes_available_message);


} else {

	jersey_sizes_players = jersey_sizes_goalies = [
	{
		size_value: 'YM',
		size_name: 'YM',
		number: 'i',
	},
	{
		size_value: 'YL',
		size_name: 'YL',
		number: 'i',
	},
	{
		size_value: 'YXL',
		size_name: 'YXL',
		number: 'i',
	},
	{
		size_value: 'XS',
		size_name: 'XS',
		number: 'i',
	},
	{
		size_value: 'S',
		size_name: 'S',
		number: 'i',
	},
	{
		size_value: 'M',
		size_name: 'M',
		number: 'i',
	},
	{
		size_value: 'L',
		size_name: 'L',
		number: 'i',
	},
	{
		size_value: 'XL',
		size_name: 'XL',
		number: 'i',
	},
	{
		size_value: 'XXL',
		size_name: 'XXL',
		number: 'i',
	},]

}



let socks_sizes_players;
let socks_sizes_goalies;

if (socks_size_option) {

	let socks_sizes_split = socks_sizes_available.split(':');

	socks_sizes_players = [];
	socks_sizes_goalies = [];

	socks_sizes_split.forEach(socks_size => {

		let number_of_size = socks_size.split('-')[0];
		if (number_of_size !== 'i') {
			number_of_size = parseInt(number_of_size);
		}
		let size_label = socks_size.split('-')[1];

		socks_sizes_players.push({ size_value: size_label,  size_name: size_label, number: number_of_size });
		socks_sizes_goalies.push({ size_value: size_label,  size_name: size_label, number: number_of_size });

	});

	console.log(socks_sizes_players);

} else {

	// ...
	// nothing here!

}


console.log(jersey_sizes_available_message);


</script>


<style>

#jerseys-table {

}

</style>



{#if jerseys_form_deadline}
<MsgCard msg_show={true} msg_text={`Deadline is: ${jerseys_form_deadline_str}. Changes are sent to us automatically.`} msg_type={'error'} msg_forever={true} />
{/if}

{#if jersey_sizes_available_message}
<MsgCard msg_show={true} msg_text={jersey_sizes_available_message} msg_type={'error'} msg_forever={true} />
{/if}

<!-- <MsgCard msg_show={true} msg_text={'For spring prospects teams: socks are assigned according to jersey sizing.'} msg_type={'error'} msg_forever={true} /> -->


<div class="panel" id="jerseys-table">

	<div class="panel-heading">

		<div class="columns is-variable is-2 is-mobile">

			<div class="column is-3-desktop is-3-touch">
				<span>Name</span>
			</div>

			<div class="column is-2-desktop is-2-touch">
				<span>Jersey #</span>
			</div>

			<div class="column is-2-desktop is-2-touch">
				{#if jersey_size_option}
					<span>Jersey Size</span>
				{/if}
			</div>

			<div class="column is-2-desktop is-2-touch">
				{#if socks_size_option}
					<span>Socks Size</span>
				{/if}
			</div>

			<div class="column is-3-desktop is-3-touch">
				<span></span>
			</div>

		</div>

	</div>

	{#each registrations as registration}
		<JerseyThumb {registration} bind:jersey_form_changes={jersey_form_changes} {team_instance_id} on:jersey_socks_saved_msg {jersey_numbers_options} {jersey_size_option} {jersey_sizes_players} {jersey_sizes_goalies} {socks_size_option} {socks_sizes_players} {socks_sizes_goalies} {jerseys_form_deadline} {last_year_jerseys_socks_info} {conference_id} />
	{/each}

</div>


{#if registrations.length === 0}
	<MsgCard msg_show={true} msg_text={'No Registrations yet!'} msg_type={'error'} msg_forever={true} />
{/if}



